import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_barber-membership-1/artifacts/lnz6qr8g_Screenshot_20260112_182038_Drive.jpg";
const VAGARO_URL = "https://www.vagaro.com/dbhgg6";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0A0A0B] border-t border-white/5">
      <div className="px-6 md:px-12 lg:px-24 py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <Link to="/">
              <img src={LOGO_URL} alt="LUXGROOM Logo" className="h-14 w-auto object-contain mb-4" />
            </Link>
            <p className="text-sm text-[#71717A] leading-relaxed font-light max-w-xs mb-4">
              Premium mobile barber service for busy professionals and athletes in the San Francisco Bay Area.
            </p>
            {/* Social */}
            <div className="flex gap-3">
              {[
                { label: "IG", url: "https://instagram.com/luxgroom" },
                { label: "FB", url: "https://facebook.com/luxgroom" },
                { label: "X", url: "https://twitter.com/luxgroom" },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-social-${s.label.toLowerCase()}`}
                  className="w-9 h-9 rounded-sm bg-white/5 border border-white/10 flex items-center justify-center text-xs text-[#A1A1AA] hover:text-[#C5A059] hover:border-[#C5A059]/30 transition-all font-medium"
                >
                  {s.label}
                </a>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-heading text-sm font-medium text-[#F3F4F6] uppercase tracking-wider mb-4">
              Navigate
            </h4>
            <div className="space-y-2 text-sm">
              <Link to="/" className="block text-[#A1A1AA] hover:text-[#C5A059] transition-colors">Home</Link>
              <Link to="/about" className="block text-[#A1A1AA] hover:text-[#C5A059] transition-colors">About</Link>
              <Link to="/services" className="block text-[#A1A1AA] hover:text-[#C5A059] transition-colors">Services</Link>
              <Link to="/membership" className="block text-[#A1A1AA] hover:text-[#C5A059] transition-colors">Membership</Link>
              <Link to="/contact" className="block text-[#A1A1AA] hover:text-[#C5A059] transition-colors">Contact</Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-sm font-medium text-[#F3F4F6] uppercase tracking-wider mb-4">
              Contact
            </h4>
            <div className="space-y-2 text-sm text-[#A1A1AA]">
              <a href="mailto:ltaplett@luxgroom.net" className="block hover:text-[#C5A059] transition-colors">ltaplett@luxgroom.net</a>
              <a href="tel:4159946699" className="block hover:text-[#C5A059] transition-colors">(415) 994-6699</a>
              <p>San Francisco Bay Area, CA</p>
              <p>Full Service — 24/7</p>
            </div>
          </div>

          {/* Booking */}
          <div>
            <h4 className="font-heading text-sm font-medium text-[#F3F4F6] uppercase tracking-wider mb-4">
              Book Now
            </h4>
            <p className="text-sm text-[#A1A1AA] mb-4">
              Schedule your appointment directly on Vagaro.
            </p>
            <a
              href={VAGARO_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-vagaro-btn"
              className="inline-flex items-center gap-2 bg-[#C5A059] text-black hover:bg-[#D4AF37] font-medium transition-all duration-300 rounded-sm px-5 py-2.5 text-xs uppercase tracking-wider"
            >
              Book on Vagaro <ExternalLink className="w-3.5 h-3.5" />
            </a>
            <p className="text-xs text-[#71717A] mt-3">
              <a href="https://www.luxgroom.net" target="_blank" rel="noopener noreferrer" className="hover:text-[#C5A059] transition-colors">
                www.luxgroom.net
              </a>
            </p>
          </div>
        </div>

        <div className="section-divider my-8" />

        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#71717A]">
            &copy; 2025 LUXGROOM Mobile Barber Technologies. All rights reserved.
          </p>
          <p className="text-xs text-[#71717A]">
            Serving the SF Bay Area with pride.
          </p>
        </div>
      </div>
    </footer>
  );
}
